import { render, staticRenderFns } from "./KitMetrics.vue?vue&type=template&id=137c671c"
import script from "./KitMetrics.vue?vue&type=script&lang=ts"
export * from "./KitMetrics.vue?vue&type=script&lang=ts"
import style0 from "./KitMetrics.vue?vue&type=style&index=0&id=137c671c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports